export default __webpack_public_path__ + "static/slide1-3bc6b5c49d4668a575870d1a984787d7.jpg";